import { useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useGeneralSettings() {
  const fetchClinic = useCallback(() => quarkusApi.get('/clinic', authHeader()), []);

  const fetchRooms = useCallback(() => quarkusApi.get('/rooms', authHeader()), []);

  const saveClinic = useCallback((payload) => quarkusApi.put('/clinic', payload, authHeader()), []);

  return { fetchClinic, fetchRooms, saveClinic };
}
